import FullScreenLayout from "../layouts/full-screen-layout";
import logo from "../resources/logo.svg";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AccountService from "../services/AccountService";

export default function AccountConfirm() {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const code = searchParams.get("code");

  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!userId || !code) {
      setStatus("error");
      return;
    }
    AccountService.confirmAccount(userId, code)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [userId, code]);

  return (
    <FullScreenLayout>
      <div className="flex-auto mt-8 shadow-none border-noround w-26rem bg-white px-4 py-4 border-1 border-300">
        <div className="flex flex-column align-items-center justify-content-center border-round m-2">
          <img src={logo} alt="logo" width={56} className="flex justify-content-center ml-5 mr-5" />
          <p className="text-color font-bold">Account Confirmation</p>
        </div>

        {status === "loading" && (
          <div className="flex flex-column align-items-center justify-content-center py-4 gap-3">
            <i className="pi pi-spin pi-spinner text-4xl text-primary" />
            <p className="text-color-secondary text-sm text-center m-0">Verifying your account, please wait…</p>
          </div>
        )}

        {status === "success" && (
          <div className="flex flex-column align-items-center justify-content-center py-4 gap-3">
            <i className="pi pi-check-circle text-4xl text-green-500" />
            <p className="text-color font-semibold text-center m-0">Your account has been confirmed!</p>
            <p className="text-color-secondary text-sm text-center m-0">You have successfully verified your account. You can now log in.</p>
            <Link to="/login" className="p-button p-component w-full flex justify-content-center no-underline mt-2">
              Back to Login
            </Link>
          </div>
        )}

        {status === "error" && (
          <div className="flex flex-column align-items-center justify-content-center py-4 gap-3">
            <i className="pi pi-times-circle text-4xl text-red-500" />
            <p className="text-color font-semibold text-center m-0">Confirmation failed</p>
            <p className="text-color-secondary text-sm text-center m-0">
              The confirmation link is invalid or has expired. Please request a new one.
            </p>
          </div>
        )}

        <Link to="/login" className="flex text-blue-500 no-underline justify-content-center w-full mt-4">
          Return to log in
        </Link>
      </div>
    </FullScreenLayout>
  );
}
